import { z } from "zod";
import { AccountSchema } from "./Account"; 

export const CreateAccountResponseSchema = AccountSchema.pick({
    id: true
}).extend({
    userId: z.number().positive().min(1),
});

export type CreateAccountResponse = z.infer<typeof CreateAccountResponseSchema>;